// extracted by mini-css-extract-plugin
export default {"__wrapper":"Home___wrapper__PQJ-o","__noPatient":"Home___noPatient__gmamx","icon":"Home_icon__2Bfi+"};